module.exports = __webpack_public_path__ + "img/5_47.a84ca6d9.png";